// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CouponMemberMoveMemberNumberBySurveyQuestionProgramIdMoveMemberNumberBySurveyQuestionResponse {
    static getAttributeTypeMap() {
        return CouponMemberMoveMemberNumberBySurveyQuestionProgramIdMoveMemberNumberBySurveyQuestionResponse.attributeTypeMap;
    }
}
CouponMemberMoveMemberNumberBySurveyQuestionProgramIdMoveMemberNumberBySurveyQuestionResponse.discriminator = undefined;
CouponMemberMoveMemberNumberBySurveyQuestionProgramIdMoveMemberNumberBySurveyQuestionResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "EnrollmentMoveMemberNumberBySurveyQuestionResultModelResponse"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    }
];
//# sourceMappingURL=couponMemberMoveMemberNumberBySurveyQuestionProgramIdMoveMemberNumberBySurveyQuestionResponse.js.map